import { Mail, Phone, MapPin, Globe } from "lucide-react";
import { SITE } from "@/lib/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#071B33] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img
                src="/ts-logo.png"
                alt="Top Service logo"
                className="h-11 w-auto object-contain"
              />
              <div className="leading-none">
                <p className="font-heading text-lg font-bold text-white">
                  Top Service
                </p>
                <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-amber-400">
                  Supplies &amp; Imports
                </p>
              </div>
            </div>
            <p className="mt-4 text-sm text-blue-100/60 leading-relaxed max-w-xs">
              {SITE.company}. Reliable procurement and import logistics from
              Alexandria, Egypt.
            </p>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-wider text-amber-400">
              Navigate
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              {[
                { label: "About Us", href: "#about" },
                { label: "Network", href: "#partners" },
                { label: "Why Us", href: "#services" },
                { label: "Contact", href: "#contact" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                    className="text-blue-100/70 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-wider text-amber-400">
              Contact
            </p>
            <ul className="mt-4 space-y-3 text-sm text-blue-100/70">
              <li>
                <a
                  href={SITE.websiteUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-website-link"
                  className="flex items-center gap-2 hover:text-white transition-colors break-all"
                >
                  <Globe className="h-4 w-4 flex-none text-amber-400" />
                  {SITE.website}
                </a>
              </li>
              <li>
                <a
                  href={SITE.mailto}
                  data-testid="footer-email-link"
                  className="flex items-center gap-2 hover:text-white transition-colors break-all"
                >
                  <Mail className="h-4 w-4 flex-none text-amber-400" />
                  {SITE.email}
                </a>
              </li>
              {SITE.phones.map((num) => (
                <li key={num}>
                  <a
                    href={`tel:${num}`}
                    className="flex items-center gap-2 hover:text-white transition-colors"
                  >
                    <Phone className="h-4 w-4 flex-none text-amber-400" />
                    {num}
                  </a>
                </li>
              ))}
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 flex-none text-amber-400 mt-0.5" />
                <span>
                  {SITE.address.street}, {SITE.address.city},{" "}
                  {SITE.address.country}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-blue-100/50">
            © 2026 {SITE.company}. All rights reserved.
          </p>
          <p className="text-xs text-blue-100/50 font-mono">
            Alexandria, Egypt
          </p>
        </div>
        <p className="mt-4 text-[11px] text-blue-100/40 leading-relaxed">
          All brand names, logos and trademarks are the property of their
          respective owners and are used for identification purposes only.
        </p>
      </div>
    </footer>
  );
};
